import FieldSet from '../../FieldSet';

import { PortalVisibility } from './PortalVisibility';

export class PortalVisibilityFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [PortalVisibility];
  }

  get title() {
    return 'Portal visibility';
  }
}
